/**
 * Insert collection advert tiles into #CollectionLoop
 * Placement matches gem-page-collection-1744726526.js.liquid
 */
(function () {
  function initCollectionAds(root) {
    var section =
      root ||
      document.querySelector('[data-section-type="collection"][data-collection-ads="true"]');
    if (!section) return;

    var grid = section.querySelector('#CollectionLoop');
    var templatesRoot = section.querySelector('[data-collection-ads-templates]');
    if (!grid || !templatesRoot) return;

    var templates = Array.prototype.slice.call(
      templatesRoot.querySelectorAll('[data-collection-ad-template]')
    );
    if (!templates.length) return;

    var currentPage = 1;
    try {
      var pageAttr = section.getAttribute('data-collection-page');
      if (pageAttr) currentPage = parseInt(pageAttr, 10) || 1;
      else {
        var params = new URLSearchParams(window.location.search);
        currentPage = parseInt(params.get('page') || '1', 10) || 1;
      }
    } catch (e) {
      currentPage = 1;
    }

    function getInsertIndices(productCount, width) {
      var insertIndices = [];
      var isMobile = width < 768;

      if (isMobile) {
        // 2-col grid: start at row index 2 (3rd row), then every other row
        var rows = Math.floor(productCount / 2);
        var promoRow = 2;

        while (promoRow < rows) {
          var insertAfterIndex = promoRow * 2;
          if (insertAfterIndex >= 0 && insertAfterIndex < productCount) {
            insertIndices.push(insertAfterIndex);
          }
          promoRow += 2;
        }
      } else {
        for (var i = 5; i < productCount; i += 6) {
          insertIndices.push(i);
        }
      }

      return { indices: insertIndices, isMobile: isMobile };
    }

    var rendering = false;
    var observer = null;

    function renderAds() {
      if (rendering) return;
      rendering = true;
      if (observer) observer.disconnect();

      grid.querySelectorAll('.product-item--ad').forEach(function (el) {
        el.remove();
      });

      var products = Array.prototype.slice.call(
        grid.querySelectorAll(
          '.product-item:not(.product-item--ad):not(.product-item--featured-image)'
        )
      );
      var productCount = products.length;
      if (!productCount) {
        rendering = false;
        if (observer) observer.observe(grid, { childList: true, subtree: false });
        return;
      }

      var placement = getInsertIndices(productCount, window.innerWidth);
      var insertIndices = placement.indices;

      insertIndices.forEach(function (insertAfterIndex, insertNumber) {
        var product = products[insertAfterIndex];
        if (!product || !product.parentNode) return;

        var template =
          templates[(currentPage - 1 + insertNumber) % templates.length];
        if (!template) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'product-item product-item--ad';
        wrapper.innerHTML = template.innerHTML;

        product.parentNode.insertBefore(wrapper, product.nextSibling);
      });

      rendering = false;
      if (observer) observer.observe(grid, { childList: true, subtree: false });
    }

    renderAds();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      if (resizeTimeout) return;
      resizeTimeout = setTimeout(function () {
        resizeTimeout = null;
        renderAds();
      }, 80);
    });

    var moTimeout;
    observer = new MutationObserver(function (mutations) {
      if (rendering) return;
      var shouldRerender = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return (
            node.nodeType === 1 &&
            node.classList.contains('product-item') &&
            !node.classList.contains('product-item--ad')
          );
        });
      });
      if (!shouldRerender) return;
      clearTimeout(moTimeout);
      moTimeout = setTimeout(renderAds, 50);
    });

    observer.observe(grid, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionAds();
    });
  } else {
    initCollectionAds();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector?.('[data-collection-ads="true"]')) {
      initCollectionAds(event.target.querySelector('[data-collection-ads="true"]'));
    }
  });
})();
